import { useCallback, useRef } from "react";
import { useIsFocused } from "@react-navigation/native";
import { useScrollContext } from "@navigations/utils/ScrollContext";
import { Platform } from "react-native";
import { useTheme } from "styled-components/native";

const useProductTypesScroll = () => {
  const isFocused = useIsFocused();
  const [scrollValue, , , , , , previousScrollValue, binaryScrollValue] =
    useScrollContext();
  const theme = useTheme();
  const SCROLL_THRESHOLD = Platform.OS === "ios" && theme.isMobile ? 10 : 30;
  const DIRECTION_CHANGE_THRESHOLD = 50;
  const NEAR_TOP = Platform.OS === "android" ? 50 : 25;
  const lastScrollY = useRef(0);
  const accumulatedDelta = useRef(0);
  const lastDirection = useRef<number | null>(null);

  const onScroll = useCallback(
    (event: any) => {
      if (!isFocused) return;

      const { contentOffset, contentSize, layoutMeasurement } =
        event.nativeEvent;
      const y = contentOffset.y;
      const maxScroll = contentSize.height - layoutMeasurement.height;

      if (y <= NEAR_TOP) {
        scrollValue.value = 0;
        binaryScrollValue.value = 0;
        accumulatedDelta.current = 0;
        lastDirection.current = null;
        lastScrollY.current = y;
        return;
      }

      if (maxScroll < 50) {
        return;
      }

      const delta = y - lastScrollY.current;
      const currentDirection = delta > 0 ? 1 : delta < 0 ? -1 : 0;

      if (currentDirection !== 0) {
        if (lastDirection.current === currentDirection) {
          accumulatedDelta.current += Math.abs(delta);
        } else {
          accumulatedDelta.current = Math.abs(delta);
        }

        if (
          lastDirection.current !== null &&
          lastDirection.current !== currentDirection
        ) {
          if (accumulatedDelta.current < DIRECTION_CHANGE_THRESHOLD) {
            lastScrollY.current = y;
            return;
          }
        }

        if (accumulatedDelta.current >= SCROLL_THRESHOLD) {
          const newBinaryValue = currentDirection > 0 ? 1 : 0;
          if (binaryScrollValue.value !== newBinaryValue) {
            binaryScrollValue.value = newBinaryValue;
          }

          const progress = Math.min(y / 100, 1);
          scrollValue.value =
            currentDirection > 0 ? progress : Math.max(0, progress - 0.3);

          lastDirection.current = currentDirection;
        }
      }

      lastScrollY.current = y;
      previousScrollValue.value = y;
    },
    [isFocused, scrollValue, binaryScrollValue, previousScrollValue]
  );

  return { onScroll };
};

export default useProductTypesScroll;
